import React, { useEffect, useState } from 'react';

import Draggable from 'react-draggable';

import { XIcon as CloseRoundedIcon } from '@phosphor-icons/react';

import { platformImages } from '@services/utils.service';
import { isZoomApp } from '@zoom-app/helpers';
import { useZoomData } from '@lib/hooks/useZoomData';

const Notification = ({ platformName = '', handleCloseNotification, layoutMode = 'rectangle', currentRosFeature }) => {
  const { setting, type } = currentRosFeature || {};
  const [notificationString, setNotificationString] = useState('');
  const isKeywordWheel = type === 'newWheel' && setting?.enableKeyword && setting?.wheelKeyword;
  const configResponse = useZoomData((s) => s.configResponse);

  const getKeyboardShortcut = () => {
    if (!isZoomApp()) return null;
    if (configResponse?.browserVersion?.includes('apple')) {
      return '⇧⌘H';
    } else if (configResponse?.browserVersion?.includes('webview')) {
      return 'Alt+H';
    }
    return 'Alt+H';
  };
  useEffect(() => {
    if (isKeywordWheel) {
      setNotificationString(<p className='text-2xl mb-[0.5rem]'>Just type "<strong>{setting?.wheelKeyword}</strong>"</p>);
    } else {
      setNotificationString('Just type');
    }
  }, [setting]);

  return (
    <Draggable bounds="parent">
      <div className={`py-4 [&>div]:animate-slideUp cursor-move absolute z-20 bg-content2 ${layoutMode === 'rectangle' ? 'left-[40%]' : 'left-[33%]'} bottom-[82px] flex flex-col items-center justify-center gap-3  min-h-[144px] px-[54px] rounded-[16px] shadow-md border border-divider scale-150 origin-bottom`}>
        <CloseRoundedIcon
          className="absolute top-2 right-2 cursor-pointer text-default-900"
          size={20}
          onClick={handleCloseNotification}
        />
        <div className={`${isKeywordWheel ? 'text-2xl' : 'text-2xl'} font-light leading-5 whitespace-nowrap text-content2-foreground`}>
          {notificationString} in the <span className="font-bold">
            {['streamyard', 'restream'].includes(platformName?.toLowerCase()) ? 'chat' : `${platformName} chat`}
          </span>
        </div>
        {typeof platformName === 'string' &&
          platformImages.map(
            (platform) =>
              platformName.match(platform.name) && (
                <img draggable="false" key={platform.name} className={platform.className} src={platform.src} alt={`${platform.name} chat`} />
              )
          )}
        {isZoomApp() && (
          <div className="text-sm font-light">
            Or use <span className="bg-grey-200 text-gray-700 rounded-sm p-1">{getKeyboardShortcut()}</span> to open the chat
          </div>
        )}
      </div>
    </Draggable>
  );
};

export default Notification;
